import { Button, Modal, Select } from '@components/common';
import { UserRole } from '@shared/types';
import React, { useEffect, useState } from 'react';
import { ROLE_OPTIONS } from './CreateUserAccountModal';

interface EditRoleModalProps {
  isOpen: boolean;
  employeeName: string;
  currentRole: UserRole;
  isSaving: boolean;
  onClose: () => void;
  onSubmit: (role: UserRole) => Promise<void>;
}

export const EditRoleModal: React.FC<EditRoleModalProps> = ({
  isOpen,
  employeeName,
  currentRole,
  isSaving,
  onClose,
  onSubmit,
}) => {
  const [role, setRole] = useState<UserRole>(currentRole);

  useEffect(() => {
    if (isOpen) setRole(currentRole);
  }, [isOpen, currentRole]);

  const handleSubmit = async () => {
    if (role === currentRole) {
      onClose();
      return;
    }
    await onSubmit(role);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Edit Role" size="sm">
      <div className="space-y-4 text-sm text-gray-900">
        <p className="text-gray-600">
          Change the role for{' '}
          <span className="font-semibold text-black">{employeeName}</span>. This
          changes what they can access across the app.
        </p>

        <Select
          label="Role"
          value={role}
          onChange={(value) => setRole(value as UserRole)}
          options={ROLE_OPTIONS}
        />

        <div className="flex items-center justify-end gap-3 pt-2">
          <Button variant="outline" onClick={onClose} disabled={isSaving}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} isLoading={isSaving}>
            Save Role
          </Button>
        </div>
      </div>
    </Modal>
  );
};
